import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@styles/color.styles";

const warning: CSSProperties = {
  marginTop: 5,
  fontSize: 12,
  lineHeight: 1.4,
  color: colors.peach.darker,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

const warningIcon: CSSProperties = {
  height: 12,
  width: 12,
  marginRight: 6,
  display: "flex",
  flexShrink: 0,
  color: colors.peach.darker,
};

const warningIconCompact: CSSProperties = {
  height: 12,
  width: 12,
  color: colors.peach.darker,
};

const warningIconCompactSelected: CSSProperties = {
  color: "white",
};

const painChip: CSSProperties = {
  backgroundColor: colors.peach.lightest,
  color: colors.peach.darker,
  marginRight: 4,
  marginBottom: 4,
};

const painChipSelected: CSSProperties = {
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  color: "white",
  marginRight: 4,
  marginBottom: 4,
};

export const styles = {
  warning,
  warningIcon,
  warningIconCompact,
  warningIconCompactSelected,
  painChip,
  painChipSelected,
};
